import "./App.css";
import Header from "./components/Header/Header";
import "./App.css";
import Footer from "./components/Footer/Footer";
import Tfaqs from "./components/TeamFaqs/Tfaqs";
import Defaultpage from "./components/Defaultpage/Defaultpage";
import { useContext, useEffect, useState } from "react";
import Roadmap from "./components/Roadmap/Roadmap";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LogoutModal from "./LogoutModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import About from "./components/About/About";
import Navbar from "./components/Navbar/Navbar";
import HeadBottom from "./components/HeaderBottom/HeadBottom";
import { AppContext } from "./utils";
import { Snackbars } from "./components/Toast/toast";
function App() {
  const [openLogout, setopenLogout] = useState(false);
  const [_network, setSwitchNetwork] = useState(false);
  const { account, chainId } = useContext(AppContext);

  // useEffect(() => {
  //   let chain = async () => {
  //     if (+chainId !== 4) {
  //       setSwitchNetwork(true);
  //     } else {
  //       setSwitchNetwork(false);
  //     }
  //   };
  //   chain();
  // }, [chainId]);

  console.log(chainId, "chainId");
  return (
    <div>
      {/* <Snackbars open={_network} setOpen={setSwitchNetwork} /> */}
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <div>
                  {/* <Zoom duration={600}> */}
                  <Navbar />
                  <Header
                    openLogout={openLogout}
                    setopenLogout={setopenLogout}
                  />
                  <div
                    className="aboutParent"
                    style={{
                      background: "#3E1057 !important",
                    }}
                  >
                    <About />
                    <div id="roadmap">
                      <Roadmap />
                    </div>
                  </div>
                  <Tfaqs />
                  <Footer />
                  <LogoutModal
                    openLogout={openLogout}
                    setopenLogout={setopenLogout}
                  />
                  <ToastContainer />
                  {/* </Zoom> */}
                </div>
              </>
            }
          />

          {/* <Route
            path="mintnft"
            element={
              <>
                <MintPage  />
              </>
            }
          /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
